import { createSlice } from '@reduxjs/toolkit'
import { v4 as generateID } from 'uuid'

const generateEditorElement = (type) => {
  const commonFields = {
    id: generateID(),
    type,
    placeHolder: 'Placeholder Label',
  }

  switch (type) {
    case 'text':
    case 'text-area':
    case 'number':
    case 'email':
    case 'date':
      return commonFields
    case 'dropdown':
    case 'checkbox':
    case 'radio': 
      return {
        ...commonFields,
        options: [
          {
            label: 'Option 1',
          },
          {
            label: 'Option 2',
          },
          {
            label: 'Option 3',
          },
        ],
      }
    default:
      return null
  }
}

export const globalSlice = createSlice({
  name: 'global',
  initialState: {
    title: '',
    editorElements: [],
    workflow: [],
  },
  reducers: {
    insertEditorElement: (state, action) => {
      const { type } = action.payload
      state.editorElements.push(generateEditorElement(type))
    },

    insertAtEditorElement: (state, action) => {
      const { index, type } = action.payload
      state.editorElements.splice(index, 0, generateEditorElement(type))
    },

    moveEditorElement: (state, action) => {
      const { from, to } = action.payload
      const editorElements = [...state.editorElements]
      const element = editorElements[from]
      editorElements.splice(from, 1)
      editorElements.splice(to, 0, element)
      state.editorElements = editorElements
    },

    removeEditorElement: (state, action) => {
      const { id } = action.payload
      state.editorElements = state.editorElements.filter(
        (element) => element.id !== id
      )
    },

    updateEditorElement: (state, action) => {
      const { id, element } = action.payload
      const editorElements = [...state.editorElements]
      const index = editorElements.findIndex((element) => element.id === id)
      editorElements[index] = element
      state.editorElements = editorElements
    },

    updateTitle: (state, action) => {
      state.title = action.payload
    },

    updateWorkflow: (state, action) => {
      state.workflow = action.payload
    },
  },
})

export const {
  insertEditorElement,
  moveEditorElement,
  insertAtEditorElement,
  removeEditorElement,
  updateEditorElement,
  updateTitle,
  updateWorkflow,
} = globalSlice.actions
export default globalSlice.reducer
